import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesWorkflowTransitionMetaAttributesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-workflow-transition-meta-attributes',
	path: '/secure/admin/ViewWorkflowTransitionMetaAttributes.jspa',
};
